import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import useIsInViewport from './useIsInViewport';
import { viewPromotion } from 'store/campaign/campaignActions';

interface UseViewPromotionEventProps {
  ref?: React.RefObject<HTMLElement>;
  promotion: {
    slot: string;
    name?: string;
    assetName?: string;
  };
}

export default function useViewPromotionEvent({ ref, promotion }: UseViewPromotionEventProps) {
  const dispatch = useDispatch();
  const isInViewport = useIsInViewport(ref);
  const usingViewport = ref?.current;
  const [fired, setFired] = useState(false);

  useEffect(() => {
    if (!promotion.name || !isInViewport || fired) return;

    dispatch(
      viewPromotion({
        promotion,
      }),
    );

    setFired(true);
  }, [dispatch, fired, isInViewport, promotion, usingViewport]);
}
